export const API_START_POINT = "https://himachal.phntechnology.com/himachal/api";

// Robotics API Endpoints
export const TEACHER_LIST_GET_API_ROBOTICS = `${API_START_POINT}/trainersList`;
export const SCHOOL_LIST_GET_API_ROBOTICS = `${API_START_POINT}/schoolsList`;
export const LOGIN_API = `${API_START_POINT}/login`;
export const VIDEO_WATCHING_PROGRESS_ROBOTICS = `${API_START_POINT}/dashboardProgressVidWatch`;
export const AVERAGE_PROGRESS_ROBOTICS = `${API_START_POINT}/averageVideoProgressAndPerformance`;
export const BEST_PERFORMING_SCHOOL_ROBOTICS = `${API_START_POINT}/bestPerformingSchool`;
export const COURSE_VIDEOS_GET_API_ROBOTICS = `${API_START_POINT}/videos`;
export const EXPORT_REPORT_GET_API_ROBOTICS = `${API_START_POINT}/download-report`;

// Drone API Endpoints
export const TEACHER_LIST_GET_API_DRONE = `${API_START_POINT}/drone-trainersList`;
export const SCHOOL_LIST_GET_API_DRONE = `${API_START_POINT}/drone-schoolsList`;
export const VIDEO_WATCHING_PROGRESS_DRONE = `${API_START_POINT}/drone-dashboardProgressVidWatch`;
export const AVERAGE_PROGRESS_ROBOTICS_DRONE = `${API_START_POINT}/drone-averageVideoProgressAndPerformance`;
export const BEST_PERFORMING_SCHOOL_DRONE = `${API_START_POINT}/drone-bestPerformingSchool`;
export const COURSE_VIDEOS_GET_API_DRONE = `${API_START_POINT}/drone-videos`;
export const EXPORT_REPORT_GET_API_DRONE  = `${API_START_POINT}/drone-download-report`;

export const POST_RESET_PASS_API = `${API_START_POINT}/reset-password`;
export const POST_EXISTING_EMAIL_API = `${API_START_POINT}/reset-password`;
export const POST_DELETE_API = `${API_START_POINT}/reset-password`;

// Principal API's
// Create Principal 
export const CREATE_PRINCIPAL_API = `${API_START_POINT}/create-principal`;
// Principal List API
export const PRINCIPALS_LIST_GET_API = `${API_START_POINT}/principalsList`;
// Teacher Transfer
export const TEACHER_TRANSFER_POST_API = `${API_START_POINT}/transfer-trainer`;

// Diet List API
export const DIET_LIST_GET_API = `${API_START_POINT}/dietsList`;

// Particular Diets Schools
// export const DIET_SCHOOLS_LIST_GET_API_ROBOTICS = `${API_START_POINT}/schoolsList/${dietId}`;
// export const DIET_SCHOOLS_LIST_GET_API_DRONE = `${API_START_POINT}/drone-schoolsList/${dietId}`

// export const DIET_SCHOOLS_LIST_API =
//   selectedSection === "Robotics"
//     ? DIET_SCHOOLS_LIST_GET_API_ROBOTICS
//     : DIET_SCHOOLS_LIST_GET_API_DRONE;

// Dynamically select API endpoints based on a stored 'selectedSection'
const selectedSection = localStorage.getItem("selectedSection");

// Particular Trainers of Schools
export const GET_DIET_SCHOOLS_TRAINERS_LIST = (schoolId) => {
  const selectedSection = localStorage.getItem("selectedSection");

  if (selectedSection === "Robotics") {
    return `${API_START_POINT}/schoolTrainersList/${schoolId}`;
  } else {
    return `${API_START_POINT}/drone-schoolTrainersList/${schoolId}`;
  }
};

//School Dashboard Video Watching Progress
export const GET_SCHOOL_DSSHBOARD_DATA = (schoolId) => {
  const selectedSection = localStorage.getItem("selectedSection");

  if (selectedSection === "Robotics") {
    return `${API_START_POINT}/schoolDashboard/${schoolId}`;
  } else {
    return `${API_START_POINT}/drone-schoolDashboard/${schoolId}`;
  }
};


export const TEACHER_LIST_GET_API =
  selectedSection === "Robotics"
    ? TEACHER_LIST_GET_API_ROBOTICS
    : TEACHER_LIST_GET_API_DRONE;
export const COURSE_VIDEOS_LIST =
  selectedSection === "Robotics"
    ? COURSE_VIDEOS_GET_API_ROBOTICS
    : COURSE_VIDEOS_GET_API_DRONE;
export const SCHOOL_LIST_GET_API =
  selectedSection === "Robotics"
    ? SCHOOL_LIST_GET_API_ROBOTICS
    : SCHOOL_LIST_GET_API_DRONE;
export const VIDEO_WATCHING_PROGRESS =
  selectedSection === "Robotics"
    ? VIDEO_WATCHING_PROGRESS_ROBOTICS
    : VIDEO_WATCHING_PROGRESS_DRONE;
export const AVERAGE_PROGRESS_GET_API =
  selectedSection === "Robotics"
    ? AVERAGE_PROGRESS_ROBOTICS
    : AVERAGE_PROGRESS_ROBOTICS_DRONE;
export const BEST_PERFORMANCE_SCHOOL_API =
  selectedSection === "Robotics"
    ? BEST_PERFORMING_SCHOOL_ROBOTICS
    : BEST_PERFORMING_SCHOOL_DRONE;
export const EXPORT_REPORT_API =
  selectedSection === "Robotics"
    ? EXPORT_REPORT_GET_API_ROBOTICS
    : EXPORT_REPORT_GET_API_DRONE;
